<!-- eslint-disable vue/no-v-html -->
<template>
  <UiModalContainer
    footer-classes="flex justify-end gap-3"
    :modal-show="modal"
    @handleClick="handleClick"
  >
    <template v-slot:header>
      <span>
        Title:
        <span class="pl-1 text-menu">{{ previewHtml?.title }}</span>
      </span>
    </template>
    <template v-slot>
      <Loader v-if="!previewHtml?.body && isLoading" class="mt-20 mb-40" :content="true" />
      <NoRecordFound v-else-if="!previewHtml?.body && !isLoading" />
      <div
        v-else
        :class="currentMedium === COMMUNICATION_MEDIUMS.SOCKET ? 'markdown-notification' : ''"
        v-html="previewHtml?.body"
      ></div>
    </template>
    <template v-slot:footer>
      <div class="flex gap-3 rtl:gap-x-4">
        <UIButton @click="handleClick('close')">Cancel</UIButton>
      </div>
    </template>
  </UiModalContainer>
</template>

<script>
import UiModalContainer from '@components/UiElements/UiModalContainer.vue'
import UIButton from '@src/components/UiElements/UIButton.vue'
import NoRecordFound from '@/src/components/BaseComponent/NoRecordFound.vue'
import Loader from '@components/BaseComponent/Loader.vue'
import { COMMUNICATION_MEDIUMS } from '@/src/constants/general-constants'
export default {
  components: {
    UiModalContainer,
    UIButton,
    NoRecordFound,
    Loader,
  },
  props: {
    modal: { type: Boolean },
    previewHtml: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    currentMedium: {
      type: String,
      default: 'email',
    },
  },
  emits: ['toggle'],
  data() {
    return { COMMUNICATION_MEDIUMS }
  },
  methods: {
    handleClick(eventName) {
      if (eventName === 'close') {
        this.$emit('toggle')
      }
    },
  },
}
</script>
